import Types from './types';

const companyStorage = JSON.parse(localStorage.getItem('company') || null);
const organizationStorage = JSON.parse(localStorage.getItem('organization') || null);

const initState = {
	organization: organizationStorage,
	company: companyStorage,
	modalSelect: false,
	triggerGetCompany: null
};

const organizationReducer = (state = initState, action) => {
	switch (action.type) {
		case Types.CHANGE_PROJECT_SELECTED: {
			return {
				...state,
				organization: null,
				company: null,
				triggerGetCompany: null
			};
		}

		case Types.CLEAR_ORGANIZATION: {
			return {
				...state,
				organization: initState.organization
			};
		}

		case Types.SET_ORGANIZATION: {
			return {
				...state,
				triggerGetCompany: action.payload.id,
				organization: action.payload
			};
		}

		case Types.SET_COMPANY: {
			return {
				...state,
				company: action.payload,
				modalSelect: false
			};
		}

		default:
			return state;
	}
};

export default organizationReducer;
